import AboutBlock from "./AboutBlock";

export default AboutBlock;
